import {Breakpoints, styled} from '@vw-marketing/us-components';

export const StyledPaginationContainer = styled.div`
  ${({theme}) => `
    width: 100%;
    padding: 0px 16px 37px 16px;
    position: relative;
    z-index: 0;
    @media screen and (min-width: ${Breakpoints.b560}px) {
        padding: 50px ${theme.size.grid002} 61px ${theme.size.grid002};
    }
`}
`;

export const StyledPaginationHeaderContainer = styled.div`
  padding-bottom: 14px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  .divider {
    height: 1px;
    background: #dfe4e8;
    margin: 14px 0;
  }
  @media screen and (min-width: ${Breakpoints.b560}px) {
    padding-bottom: 28px;
  }
  @media screen and (min-width: ${Breakpoints.b960}px) {
    padding-bottom: 0;
    justify-content: space-between;
    flex-direction: row;

    .divider {
      width: 100%;
      order: 1;
    }
  }
`;

export const StyledPaginationContentContainer = styled.div``;

export const StyledPaginationFooterContainer = styled.div`
  padding-top: 41px;
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 0;
  @media screen and (min-width: ${Breakpoints.b560}px) {
    padding-top: 85px;
  }
  @media screen and (min-width: ${Breakpoints.b960}px) {
    justify-content: end;
  }
`;
